import React from 'react'
import FontAwesome from "react-fontawesome"

class NavbarButton extends React.Component {
  render() {
    const { onClick, ariaExpanded, count, iconName, iconBgColor, title, innerRef } = this.props

    return (
      <button
        ref={ innerRef }
        onClick={ onClick }
        className="nav-btn-trigger"
        aria-label="Toggle notifications"
        aria-expanded={ ariaExpanded }
        type="button"
        title={ title }
      >
        <FontAwesome name={ iconName } />
        { count > 0 && <span className={`nav-btn-badge ${ iconBgColor }`}>{ count > 99 ? '99+' : count }</span> }
      </button>
    )
  }
}

export default NavbarButton



// WEBPACK FOOTER //
// ./src/components/App/NavbarButton.js